import React from 'react';
import { Check, X } from 'lucide-react';

const RULES = [
  { key: 'length', label: 'Minimo 8 caracteres', test: (p) => p.length >= 8 },
  { key: 'upper', label: 'Uma letra maiuscula', test: (p) => /[A-Z]/.test(p) },
  { key: 'lower', label: 'Uma letra minuscula', test: (p) => /[a-z]/.test(p) },
  { key: 'number', label: 'Um numero', test: (p) => /\d/.test(p) },
  { key: 'special', label: 'Um caractere especial (!@#$...)', test: (p) => /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(p) },
];

export function PasswordStrength({ password }) {
  if (!password) return null;
  const passed = RULES.filter(r => r.test(password)).length;
  const total = RULES.length;
  const pct = (passed / total) * 100;
  const color = pct < 40 ? 'bg-red-500' : pct < 80 ? 'bg-amber-500' : 'bg-emerald-500';

  return (
    <div className="space-y-2 mt-2" data-testid="password-strength">
      <div className="h-1.5 bg-gray-200 rounded-full overflow-hidden">
        <div className={`h-full ${color} transition-all duration-300`} style={{ width: `${pct}%` }} />
      </div>
      <div className="grid grid-cols-2 gap-1">
        {RULES.map(r => {
          const ok = r.test(password);
          return (
            <div key={r.key} className={`flex items-center gap-1.5 text-xs ${ok ? 'text-emerald-600' : 'text-muted-foreground'}`} data-testid={`rule-${r.key}`}>
              {ok ? <Check className="w-3 h-3" /> : <X className="w-3 h-3" />}
              {r.label}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export function isStrongPassword(password) {
  return RULES.every(r => r.test(password));
}
